import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import UserLogin from "./components/UserLogin";
import LandingPage from "./pages/LandingPage";
import LoanApplication from "./pages/Vehicle";
import GoldLoan from "./pages/GoldLoan";
import AdminPage from "./pages/AdminPage";
import LoanSelectionPage from "./pages/LoanSelectionPage";
import UserDetails from "./components/UserDetails";
import AddUserPage from "./pages/AddUserPage";
import LoanDetailsPage from "./pages/LoanDetailsPage";
import EMICalculator from "./components/EMICalculator";
import UpdateUser from "./components/UpdateUser";
import VelavanFinance from "./pages/VelavanFinance";
import DueMatters from "./pages/DueMatters";
import AdminDashBoard from "./components/AdminDashBoard";
import InterestCalculation from "./pages/InterestCalculation";
import ContactPage from "./components/ContactPage";
import DailyAccounts from "./pages/DailyAccounts";
import YearlySummaryPage from "./pages/FinalAccounts";
// import DailyAccountsGraphPage from "./pages/Graph";
import MonthlyAccountsGraphPage from "./pages/MonthlyAccountsGraph";
import UserManagement from "./components/UserManagement";
import RoleGuard from "./components/RoleGuard";
import CustomerDashboard from "./pages/CustomerDetails";
import AccountStatus from "./pages/AccountStatus";
import CommonUserLogin from "./pages/CommonUserLogin";
import BranchSelection from "./pages/BranchSelectionaPage";
import AddCommonUserPage from "./pages/AddCommonUser";

function App() {
  const SessionData = JSON.parse(sessionStorage.getItem("user") || "null");
  const isAdmin = SessionData?.role === "Admin Manager" || SessionData?.role === "Branch Admin" || SessionData?.role === "Client";
  console.log("Is Admin:", isAdmin, "Role:", SessionData?.role);

  return (
    <div>
      <Routes>
        {SessionData ? (
          <>
            <Route
              path="/admin"
              element={
                <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                  <AdminPage />
                </RoleGuard>
              }
            />
            {isAdmin ? (
              <>
                <Route path="/" element={<AdminDashBoard />} />
                <Route path="/manage-users" element={<UserManagement />} />
                <Route
                  path="/add-user"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin"]}>
                      <AddUserPage />
                    </RoleGuard>
                  }
                />

                <Route path="/loan-details" element={<LoanDetailsPage />} />
                <Route
                  path="/update-user"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <UpdateUser />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/velavan-finance"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <VelavanFinance />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/due-matters"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <DueMatters />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/interestCalculation"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <InterestCalculation />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/dailyAccounts"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <DailyAccounts />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/finalAccounts"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <YearlySummaryPage />
                    </RoleGuard>
                  }
                />
                {/* <Route path="/graph" element={<DailyAccountsGraphPage />} /> */}
                <Route path="/monthly-graph" element={<MonthlyAccountsGraphPage />} />
              </>
            ) : (
              <>
                <Route path="/" element={<UserDetails />} />
                <Route path="/manage-users" element={<UserManagement />} />
                <Route
                  path="/update-user"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <UpdateUser />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/velavan-finance"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <VelavanFinance />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/due-matters"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <DueMatters />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/interestCalculation"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <InterestCalculation />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/dailyAccounts"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <DailyAccounts />
                    </RoleGuard>
                  }
                />
                <Route
                  path="/finalAccounts"
                  element={
                    <RoleGuard allowedRoles={["Admin Manager", "Branch Admin", "Client"]}>
                      <YearlySummaryPage />
                    </RoleGuard>
                  }
                />
              </>
            )}
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/account-status" element={<AccountStatus />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : (
          <>

            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<UserLogin />} />
            <Route path="/CommonUserLogin" element={<CommonUserLogin />} />
            <Route path="/AddCommonUserPage" element={<AddCommonUserPage />} />
            <Route path="/branchSelection" element={<BranchSelection />} />
            <Route path="/emi" element={<EMICalculator />} />
            <Route path="/vehicle-loan" element={<LoanApplication />} />
            <Route path="/gold-loan" element={<GoldLoan />} />
            <Route path="/loan-selection" element={<LoanSelectionPage />} />
            <Route path="/customerDetails" element={<CustomerDashboard />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </div>
  );
}

export default App;